module.exports = __webpack_public_path__ + "img/lg_ring_r_o_null_1.afed8cbc.png";